import React, { Component } from "react";
import PropTypes from "prop-types";
import { Checkbox } from "semantic-ui-react";

export default class InputBox extends Component {
    static propTypes = {
        target: PropTypes.string.isRequired,
    };

    onChange = (e, data) => {
        this.props.action(this.props.target, data.checked);
        if (!!this.props.secondaryAction) {
            this.props.secondaryAction(this.props.target, data.checked);
        }
    };

    render() {
        return (
            <Checkbox
                toggle
                checked={this.props.checked}
                label={this.props.label}
                onChange={this.onChange.bind(this)}
                style={{ zIndex: 0 }}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/checkbox.js